export * from './src/innovation-assistant-v2-statistics-statistics.meta.js';
